import * as React from "react";
import { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Tabs,
  Tab,
  List,
  Divider,
  Grid2,
  Alert,
} from "@mui/material";
import dayjs from "dayjs";
import useAsyncEffect from "use-async-effect";
import { useDispatch, useSelector } from "react-redux";
import JobListItem from "./JobListItem";
import JobDialog from "./JobDialog";
import { setJobs, removeJob } from "../redux/jobSlice";
import { JobsAPI } from "../apis/jobsApi";
import JobDetailsDialog from "./JobDetailsDialog";
import constants from "../static/constants.json";
import { useParams } from "react-router";
import { RequestsAPI } from "../apis/requestsAPI";
import { setRequests } from "../redux/requestSlice";
import { useNavigate } from "react-router";
import { Link } from "react-router-dom";
function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ManagerView = () => {
  const navigate = useNavigate();
  const [tabValue, setTabValue] = useState(0);
  const dispatch = useDispatch();
  const user = useSelector((state: any) => state.user);
  const jobs = useSelector((state: any) => state.jobs.list || []);
  const requests = useSelector((state: any) => state.requests.list || []);
  const [selectedJob, setSelectedJob] = useState({} as any);
  const [viewingJob, setViewingJob] = useState({} as any);
  const [filteredJobs, setFilteredJobs] = useState(jobs);

  const [reviewingJobs, setReviewingJobs] = useState([] as any[]);
  const [creatingJob, setCreatingJob] = useState(false);

  const [jobToDelete, setJobToDelete] = useState({} as any);

  const wildcard = useParams()["*"];

  useEffect(() => {
    console.log("wildcard changed", wildcard);
    if (wildcard && wildcard !== "") {
      const j = jobs.find((j: any) => j.id === wildcard);
      if (j) {
        setViewingJob(j);
      }
    } else {
      setViewingJob({});
    }
  }, [wildcard, jobs]);

  useEffect(() => {
    console.log("got a jobs update");
    setCorrectJobsToShow();
  }, [jobs, tabValue]); // eslint-disable-line

  const setCorrectJobsToShow = () => {
    const completeJobs = jobs.filter(
      (j: any) =>
        j.assigneeId != null && j.statusId === constants.jobStatus.completed
    );
    setReviewingJobs(completeJobs);

    switch (tabValue) {
      case 0:
        const unassignedJobs = jobs.filter(
          (j: any) =>
            j.assigneeId == null &&
            dayjs(j.endTime).isAfter(dayjs()) && // TODO move expired jobs elsewhere?
            j.statusId === constants.jobStatus.open
        );
        setFilteredJobs(unassignedJobs);
        break;
      case 1:
        const assignedJobs = jobs.filter(
          (j: any) =>
            j.assigneeId != null && j.statusId === constants.jobStatus.assigned
        );
        setFilteredJobs(assignedJobs);
        break;
      case 2:
        const completedJobs = jobs.filter(
          (j: any) =>
            j.assigneeId != null && (j.statusId === constants.jobStatus.accepted || j.statusId === constants.jobStatus.rejected)
        );
        setFilteredJobs(completedJobs);
        break;

      case 3:
        const expiredJobs = jobs.filter((j: any) =>
          dayjs(j.endTime).isBefore(dayjs()) && j.statusId === constants.jobStatus.open
        );
        setFilteredJobs(expiredJobs);
        break;

      default:
        break;
    }
  };

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  useAsyncEffect(async () => {
    try {
      console.log('MANAGER VIEW')
      const js = await JobsAPI.listJobs();
      console.log("js are ", js);
      dispatch(setJobs(js || []));
    } catch (e) {
      
    }
  }, []);

  useAsyncEffect(async () => {
    const js = await RequestsAPI.getRequests();
    dispatch(setRequests(js || []));
  }, []);

  const deleteJob = async (id: string) => {
    try {
      await JobsAPI.deleteJob(id);
      dispatch(removeJob({ id }));
    } catch (error) {
      console.log("error deleting", error);
    }
  };

  const jobsContent = (
    <List
      sx={{
        width: "100%",
        bgcolor: "background.paper",
        border: "1px none red",
      }}
    >
      {filteredJobs.map((j: any, i: number) => (
        <div>
          <JobListItem
            job={j}
            onView={() => {
              // setViewingJob(j);
              navigate(`/jobs/${j.id}`);
            }}
            onSelect={() => {
              // setViewingJob(j);
              navigate(`/jobs/${j.id}`);
            }}
            onEdit={() => {
              setSelectedJob(j);
            }}
            onDelete={() => {
              setJobToDelete(j);
            }}
            onDuplicate={() => {
              const duplicateJob = {
                ...j,
              };
              delete duplicateJob.id;
              setCreatingJob(true);
              console.log("now its ", duplicateJob);
              setSelectedJob(duplicateJob);
            }}
          />
          {i !== jobs.length - 1 ? (
            <Divider variant="inset" component="li" />
          ) : null}
        </div>
      ))}
    </List>
  );
  const reviewingJobsContent =
    reviewingJobs.length > 0 ? (
      <Grid2 size={12} sx={{ width: "100%", border: "1px none green" }}>
        <List
          sx={{
            width: "100%",
            bgcolor: "background.paper",
            border: "1px none red",
          }}
        >
          {reviewingJobs.map((j: any, i: number) => (
            <div>
              <JobListItem
                job={j}
                onSelect={() => {
                  navigate(`/jobs/${j.id}`);
                  // setViewingJob(j);
                }}
                onEdit={() => {
                  setSelectedJob(j);
                }}
                onDelete={() => {
                  // setJobToDelete(j);
                }}
              />
              {i !== jobs.length - 1 ? (
                <Divider variant="inset" component="li" />
              ) : null}
            </div>
          ))}
        </List>
      </Grid2>
    ) : null;

  const tabsContent = (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          aria-label="basic tabs"
        >
          <Tab label="Open" {...a11yProps(0)} />
          <Tab label="Assigned" {...a11yProps(1)} />
          <Tab label="Completed" {...a11yProps(2)} />
          <Tab label="Expired" {...a11yProps(2)} />
        </Tabs>
      </Box>
    </Box>
  );

  const pendingRequestsContent =
    requests && requests.length > 0 ? (
      <>
        <Alert severity="warning" style={{width: '100%', marginTop: '0.4rem'}}>
          {" "}
          You have pending job requests, please{" "}
          <Link to={`/jobs/${requests[0].jobId}`}>review now</Link>
        </Alert>
        <Grid2 size={12} sx={{ width: "100%", border: "1px none green" }}>
          {/* <List
          sx={{
            width: "100%",
            bgcolor: "background.paper",
            border: "1px none red",
          }}
        >
          {requestedJobs.map((j: any, i: number) => (
            <div>
              <JobListItem
                job={j}
                onView={() => {
                  setViewingJob(j);
                }}
                onSelect={() => {
                  setViewingJob(j);
                }}
                onEdit={() => {
                  setSelectedJob(j);
                }}
                onDelete={() => {
                  setJobToDelete(j);
                }}
              />
              {i !== jobs.length - 1 ? (
                <Divider variant="inset" component="li" />
              ) : null}
            </div>
          ))}
        </List> */}
        </Grid2>
      </>
    ) : null;

  const actionNeededTabsContent =
    reviewingJobs.length > 0 ? (
      <>
        <Grid2
          size={12}
          sx={{ display: "flex", justifyContent: "left", paddingTop: "3rem" }}
        >
          <Box sx={{ width: "100%" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs
                value={0}
                onChange={() => {}}
                aria-label="waiting review tabs"
              >
                <Tab label="Waiting for Review" {...a11yProps(0)} />
              </Tabs>
            </Box>
          </Box>
        </Grid2>
        <Grid2 size={12} sx={{ display: "flex", justifyContent: "center" }}>
          <Alert severity="warning" style={{ width: "100%" }}>
            Please review these completed jobs
          </Alert>
        </Grid2>
      </>
    ) : null;

  const getNoJobsText = () => {
    switch (tabValue) {
      case 0:
        return "You have no pending job posts.";
      case 1:
        return "No jobs have been assigned";
      case 2:
        return "No jobs have been completed";
      case 3:
        return "No jobs have expired";
      default:
        return "";
    }
  };

  const noJobsContent = <Box sx={{ marginTop: "2rem" }}>{getNoJobsText()}</Box>;

  return (
    <>
      <JobDetailsDialog
        job={viewingJob}
        open={!!viewingJob.id}
        handleClose={() => {
          // setViewingJob({});
          window.history.back();
        }}
      />
      <JobDialog
        open={creatingJob || selectedJob.id}
        handleClose={() => {
          setSelectedJob({});
          setCreatingJob(false);
        }}
        job={selectedJob || {}}
      />
      <Dialog open={jobToDelete.id}>
        <DialogTitle>Are you sure?</DialogTitle>
        <DialogContent>
          {/* This action will delete {addressToString(propertyToDelete.address)} */}
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="error"
            onClick={() => {
              deleteJob(jobToDelete.id);
              setJobToDelete({} as any);
            }}
          >
            Yes
          </Button>
          <Button>no</Button>
        </DialogActions>
      </Dialog>
      <Grid2 container sx={{ margin: "1rem" }}>
        <Grid2 size={12}>
          <Box
            sx={{
              flexGrow: 1,
              border: "1px none green",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography>
              Hi, {user.firstName}! Here are your job posts:
            </Typography>
            <Button
              variant="contained"
              style={{
                width: "10rem",
                borderRadius: "1.25rem",
                fontFamily: "Arial",
              }}
              onClick={() => setCreatingJob(true)}
            >
              Post A Job
            </Button>
          </Box>
        </Grid2>

        {actionNeededTabsContent}
        {pendingRequestsContent}
        {reviewingJobsContent}
        {/* <Grid2
          size={12}
          sx={{ display: "flex", justifyContent: "left", paddingTop: "3rem" }}
        >
          {jobs.length > 0 ? "Your posted jobs" : null}
        </Grid2> */}
        <Grid2
          size={12}
          sx={{ display: "flex", justifyContent: "left", paddingTop: "3rem" }}
        >
          {tabsContent}
        </Grid2>
        <Grid2 size={12} sx={{ width: "100%", border: "1px none green" }}>
          {filteredJobs.length > 0 ? jobsContent : noJobsContent}
        </Grid2>
      </Grid2>
    </>
  );
};

export default ManagerView;
